/**
 * FullBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type FullBox = {
	version: number;
	flags: number;
};
